import type { InsurableItemMetadata } from '@newfront-insurance/coverage-api';
import type { NextApiSubscription, ConfigInterface } from '@newfront-insurance/next-api-swr';
import { useNextApiSubscription } from '@newfront-insurance/next-api-swr';
import { useContext } from 'react';

import { routes } from '../bff/routes';
import type { GetInsurableItemMetadataParams, GetInsurableItemMetadataResponse } from '../bff/types';
import { CoverageApiContext } from '../provider';

interface Params extends Omit<GetInsurableItemMetadataParams, 'insurableItemVersion'> {
  insurableItemVersion?: number;
}

export function useInsurableItemMetadata(
  params: Params,
  config?: ConfigInterface,
): NextApiSubscription<InsurableItemMetadata | null> {
  const { basePath } = useContext(CoverageApiContext);

  return useNextApiSubscription<GetInsurableItemMetadataResponse | null>(
    routes.insurableItemMetadata.getUrl(
      {
        ...params,
        insurableItemVersion: params.insurableItemVersion?.toString() ?? undefined,
      },
      basePath,
    ),
    config,
  );
}
